import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "rich-text-field"
};
const _hoisted_2 = {
  class: "relative rounded-xl border border-slate-200 bg-white"
};
const _hoisted_3 = {
  key: 0,
  class: "rich-text-field-preview prose max-h-40 overflow-y-auto px-4 py-3 pr-16 text-sm leading-relaxed text-slate-600"
};
const _hoisted_4 = {
  class: "rich-text-field-modal px-6 py-4"
};
import { computed, ref } from 'vue';
import AppModal from '@/components/AppModal.vue';
import RichTextEditor from '@/components/RichTextEditor.vue';
export default {
  __name: 'RichTextField',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '编辑内容'
    },
    placeholder: {
      type: String,
      default: '暂无内容，点击编辑'
    },
    editorPlaceholder: {
      type: String,
      default: '请输入内容...'
    },
    uploadModule: {
      type: String,
      default: 'editor'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const showEditor = ref(false);
    const draft = ref('');
    const hasContent = computed(() => Boolean(props.modelValue && props.modelValue.trim()));
    function openEditor() {
      draft.value = props.modelValue || '';
      showEditor.value = true;
    }
    function handleConfirm() {
      emit('update:modelValue', draft.value);
      showEditor.value = false;
    }
    function handleCancel() {
      showEditor.value = false;
    }
    return (_ctx, _cache) => {
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
        type: "button",
        class: "absolute right-2 top-2 z-10 rounded-lg border border-slate-200 bg-white/90 px-2.5 py-1 text-xs font-medium text-primary-700 shadow-sm transition-colors hover:bg-primary-50",
        onClick: openEditor
      }, " 编辑 "), hasContent.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, null, 512)), [[_directive_safe_html, __props.modelValue]]) : (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: "flex h-20 w-full items-center justify-center text-sm text-slate-400",
        onClick: openEditor
      }, _toDisplayString(__props.placeholder), 1))]), _createVNode(AppModal, {
        visible: showEditor.value,
        title: __props.title,
        size: "5xl",
        "z-index": 60,
        "close-on-overlay": false,
        scrollable: false,
        onClose: handleCancel
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: handleCancel
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: handleConfirm
        }, "完成")]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(RichTextEditor, {
          modelValue: draft.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => draft.value = $event),
          placeholder: __props.editorPlaceholder,
          "upload-module": __props.uploadModule,
          "min-height": "55vh"
        }, null, 8, ["modelValue", "placeholder", "upload-module"])])]),
        _: 1
      }, 8, ["visible", "title"])]);
    };
  }
};